import { render, staticRenderFns } from "./Xarajat.vue?vue&type=template&id=5f9e68c4&scoped=true"
import script from "./Xarajat.vue?vue&type=script&lang=js"
export * from "./Xarajat.vue?vue&type=script&lang=js"
import style0 from "./Xarajat.vue?vue&type=style&index=0&id=5f9e68c4&prod&lang=css"
import style1 from "./Xarajat.vue?vue&type=style&index=1&id=5f9e68c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e68c4",
  null
  
)

export default component.exports